// Factory, not a plain object literal - this module is registerModule()'d
// into the shared SSR store on every request (see ../index.js's install()),
// but only evaluated once under a reused SSR context (runInNewContext:
// 'once'/false). A plain object here would be the same live reference for
// every store that registers it, leaking sitegate/age-gate state (and its
// activation status) across requests and tenant sites.
export default () => ({
  activationStatus: 'pending',
  settings: {}, // Loaded from thesaurum.
  defaultSettings: {
    configuration: {
      initialLoadGate: null,
      timestamp: null
    },
    'age-gate': {
      configuration: {
        expiry: {
          type: 'weeks',
          duration: 1
        },
        forcedInvalidation: false,
        invalidationTimestamp: null
      }
    },
    'age-gate-new': {
      active: false,
      configuration: {
        expiry: {
          type: 'weeks',
          duration: 1
        },
        forcedInvalidation: false,
        invalidationTimestamp: null
      },
      styling: {
        theme: { // expect that the data / combinations will change here
          mainTheme: 'museum',
          subsetTheme: 'light-accent-1',
          subsetContrastTheme: 'type-1'
        },
        modalSize: 'lg', // don't go below md use, md, l g ot xl
        modalLogoSize: 'medium',
        modalBorderStyle: 'large',
        modalBorderRadius: 'small',
        submitType: 'pill',
        submitStyle: 'solid',
        submitSize: 'standard',
        submitIcon: ''
      },
      content: {
        logo: '/dist/logos/website/age-gate-new-logo.svg',
        title: 'We have to ask.',
        description: 'You need to be 18 years old or over to enter & purchase wines.',
        buttonTitle: 'Yes, I\'m Over 18'
      }
    },
    'content-sitegate': {
      active: false,
      configuration: {
        expiry: {
          type: 'weeks',
          duration: 3
        },
        forcedInvalidation: false,
        invalidationTimestamp: null
      },
      styling: {
        modalTheme: {
          mainTheme: 'flamingo',
          subsetTheme: 'dark-accent-1',
          subsetContrastTheme: 'type-2'
        },
        imageTintStrength: 40,
        imageTintStyle: 'vignette',
        salesLogo: '/dist/logos/website/content-sitegate-logo.svg',
        salesImage: '/dist/images/sitegates/content/background.jpg',
        modalContentDirection: 'row',
        modalContentDesktopPosition: 'right',
        primaryLinkButtonType: 'pill',
        primaryLinkButtonStyle: 'solid',
        primaryLinkTarget: false,
        primaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonText: 'Learn More',
        secondaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonType: 'pill',
        secondaryLinkButtonStyle: 'outline',
        secondaryLinkTarget: false
      },
      content: {
        salesTitle: 'Free shipping is a limited time offer.',
        salesLead: 'Restricted to a maximum of 10 qualifying wineries per month.',
        couponCodeActive: true,
        salesCouponCode: '20OFF',
        salesCouponLabel: 'Coupon Code',
        salesDescription: '<p>To qualify you must be a family/boutique winery who needs our support.</p><p>So contact us today and in just 21 days, you can start to reap the <a href="https://vincreative.com/features">benefits</a> of this unified DTC solution to turbocharge your online wine sales.</p>',
        salesConditionText: 'New customers only. Minimum spend $100, maximum discount $30.',
        primaryButtonActive: false,
        primaryButtonAction: 'url',
        primaryLinkButtonText: 'Learn More',
        primaryLinkButtonUrl: '/signup',
        secondaryButtonActive: false,
        secondaryButtonAction: 'url',
        secondaryLinkButtonUrl: '/signup',
        secondaryLinkButtonText: 'Learn More'
      }
    },
    'signup-sitegate': {
      active: false,
      configuration: {
        expiry: {
          type: 'weeks',
          duration: 1
        },
        forcedInvalidation: false,
        invalidationTimestamp: null
      },
      styling: {
        modalTheme: {
          mainTheme: 'flamingo',
          subsetTheme: 'dark-accent-1',
          subsetContrastTheme: 'type-2'
        },
        imageTintStrength: 40,
        imageTintStyle: 'vignette',
        salesLogo: '/dist/logos/website/signup-sitegate-logo.svg',
        salesImage: '/dist/images/sitegates/signup/background.jpg',
        modalContentDirection: 'row',
        modalContentDesktopPosition: 'right',
        primaryLinkButtonType: 'pill',
        primaryLinkButtonStyle: 'solid',
        primaryLinkTarget: false,
        primaryLinkButtonIcon: 'arrow',
        secondaryButtonActive: false,
        secondaryLinkButtonText: 'Learn More',
        secondaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonType: 'pill',
        secondaryLinkButtonStyle: 'outline',
        secondaryLinkTarget: false
      },
      content: {
        signupTitle: 'Signup',
        signupDescription: '',
        salesTitle: 'Free shipping is a limited time offer.',
        salesLead: 'Restricted to a maximum of 10 qualifying wineries per month.',
        couponCodeActive: true,
        salesCouponCode: '20OFF',
        salesCouponLabel: 'Coupon Code',
        salesDescription: '<p>To qualify you must be a family/boutique winery who needs our support.</p><p>So contact us today and in just 21 days, you can start to reap the <a href="https://vincreative.com/features">benefits</a> of this unified DTC solution to turbocharge your online wine sales.</p>',
        salesConditionText: 'New customers only. Minimum spend $100, maximum discount $30.',
        primaryButtonActive: false,
        primaryButtonAction: 'url',
        primaryLinkButtonText: 'Learn More',
        primaryLinkButtonUrl: '/signup',
        secondaryButtonActive: false,
        secondaryButtonAction: 'url',
        secondaryLinkButtonUrl: '/signup',
        secondaryLinkButtonText: 'Learn More'
      }
    },
    'account-activation-success': {
      active: false,
      configuration: {
        expiry: {
          type: 'weeks',
          duration: 1
        },
        forcedInvalidation: false,
        invalidationTimestamp: null
      },
      styling: {
        modalTheme: {
          mainTheme: 'flamingo',
          subsetTheme: 'dark-accent-1',
          subsetContrastTheme: 'type-2'
        },
        imageTintStrength: 40,
        imageTintStyle: 'vignette',
        salesLogo: '/dist/logos/website/account-activation-success-logo.svg',
        salesImage: '/dist/images/sitegates/account-activation-success/background.jpg',
        modalContentDirection: 'row',
        modalContentDesktopPosition: 'right',
        primaryLinkButtonType: 'pill',
        primaryLinkButtonStyle: 'solid',
        primaryLinkTarget: false,
        primaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonText: 'Learn More',
        secondaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonType: 'pill',
        secondaryLinkButtonStyle: 'outline',
        secondaryLinkTarget: false
      },
      content: {
        salesTitle: 'Free shipping is a limited time offer.',
        salesLead: 'Restricted to a maximum of 10 qualifying wineries per month.',
        couponCodeActive: true,
        salesCouponCode: '20OFF',
        salesCouponLabel: 'Coupon Code',
        salesDescription: '<p>To qualify you must be a family/boutique winery who needs our support.</p><p>So contact us today and in just 21 days, you can start to reap the <a href="https://vincreative.com/features">benefits</a> of this unified DTC solution to turbocharge your online wine sales.</p>',
        salesConditionText: 'New customers only. Minimum spend $100, maximum discount $30.',
        primaryButtonActive: false,
        primaryButtonAction: 'url',
        primaryLinkButtonText: 'Learn More',
        primaryLinkButtonUrl: '/signup',
        secondaryButtonActive: false,
        secondaryButtonAction: 'url',
        secondaryLinkButtonUrl: '/signup',
        secondaryLinkButtonText: 'Learn More'
      }
    },
    'account-activation-error': {
      active: false,
      configuration: {
        expiry: {
          type: 'weeks',
          duration: 1
        },
        forcedInvalidation: false,
        invalidationTimestamp: null
      },
      styling: {
        modalTheme: {
          mainTheme: 'flamingo',
          subsetTheme: 'dark-accent-1',
          subsetContrastTheme: 'type-2'
        },
        imageTintStrength: 40,
        imageTintStyle: 'vignette',
        salesLogo: '/dist/logos/website/account-activation-error-logo.svg',
        salesImage: '/dist/images/sitegates/account-activation-success/background.jpg',
        modalContentDirection: 'row',
        modalContentDesktopPosition: 'right',
        primaryLinkButtonType: 'pill',
        primaryLinkButtonStyle: 'solid',
        primaryLinkTarget: false,
        primaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonText: 'Learn More',
        secondaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonType: 'pill',
        secondaryLinkButtonStyle: 'outline',
        secondaryLinkTarget: false
      },
      content: {
        salesTitle: 'Free shipping is a limited time offer.',
        salesLead: 'Restricted to a maximum of 10 qualifying wineries per month.',
        couponCodeActive: true,
        salesCouponCode: '20OFF',
        salesCouponLabel: 'Coupon Code',
        salesDescription: '<p>To qualify you must be a family/boutique winery who needs our support.</p><p>So contact us today and in just 21 days, you can start to reap the <a href="https://vincreative.com/features">benefits</a> of this unified DTC solution to turbocharge your online wine sales.</p>',
        salesConditionText: 'New customers only. Minimum spend $100, maximum discount $30.',
        primaryButtonActive: false,
        primaryButtonAction: 'url',
        primaryLinkButtonText: 'Learn More',
        primaryLinkButtonUrl: '/signup',
        secondaryButtonActive: false,
        secondaryButtonAction: 'url',
        secondaryLinkButtonUrl: '/signup',
        secondaryLinkButtonText: 'Learn More'
      }
    },
  }
})
